// @ts-expect-error
import {browserHistory} from '@pb/kit-history';

export const addHash = (hash: string) => {
    const currentLocation = browserHistory.location;

    if (currentLocation.hash === `#${hash}`) {
        return;
    }

    browserHistory.replace({
        pathname: currentLocation.pathname,
        search: currentLocation.search,
        hash: `#${hash}`,
    });
};
